import AppSelect from '../../../shared/components/AppSelect';
import type { DraftPair } from '../../challenges/types/challengeDraft';

export function assignPocoPairToSlot(pairs: DraftPair[], slot: number, pairId: string) {
  const source = pairs.findIndex(pair => pair.id === pairId);
  if (source < 0 || slot < 0 || slot >= pairs.length) return pairs;
  const next = [...pairs];
  [next[slot], next[source]] = [next[source], next[slot]];
  return next;
}

export default function PocoInitialCourts({ pairs, onChange, disabled }: {
  pairs: DraftPair[]; onChange: (pairs: DraftPair[]) => void; disabled: boolean;
}) {
  return <div className="admin-category-rounds-panel">
    <h4>Quadras da primeira rodada</h4>
    {Array.from({ length: Math.floor(pairs.length / 2) }, (_, court) =>
      <div className="admin-category-rounds-toolbar" key={court}>
        {[0, 1].map(side => {
          const slot = court * 2 + side;
          const label = `Quadra ${court + 1} · Dupla ${side + 1}`;
          return <label className="field" key={side}>
            <span>{label}</span>
            <AppSelect aria-label={label} value={pairs[slot].id} disabled={disabled}
              onChange={event => onChange(assignPocoPairToSlot(pairs, slot, event.target.value))}>
              {pairs.map(pair => <option key={pair.id} value={pair.id}>{pair.label}</option>)}
            </AppSelect>
          </label>;
        })}
      </div>)}
  </div>;
}
